import {secondsToTime, timeToSeconds} from '../filters'
import BaseModel from '@/models/baseModel'

class Sequence extends BaseModel {
  collections = {}
  description = {
    data: {
      filmPersons: {},
      places: {},
      // keywords: {}
      macrotags: {},
      microtags: {}
    }
  }

  constructor (create, data) {
    super()
    if (create) {
      this.isNew = true
    }
    if (data !== undefined) {
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })

      this.durata = secondsToTime(this.durata)
      this.end = secondsToTime(this.end)
      this.start = secondsToTime(this.start)
    }
  }

  prepareForSend () {
    let data = _.cloneDeep(this)
    data.durata = timeToSeconds(data.durata)
    data.end = timeToSeconds(data.end)
    data.start = timeToSeconds(data.start)
    return data
  }
}

export default Sequence



// WEBPACK FOOTER //
// ./src/models/sequence.js